export const price2cents = (price: string) => {
  const priceCents = price.replace(/\D/g, "")
  return Number(priceCents)
}
